import React from 'react';
import StorefrontHeroActions from './StorefrontHeroActions';
/** Headline, CTAs, trust pills — shared by split and immersive hero layouts. */
export default function HomeHeroCopyPanel({
  compact,
  brandName,
  title,
  subtitle,
  description,
  trustItems,
  trustIcon: TrustIcon,
  immersive,
}) {
  const luxury = immersive && !compact;

  return (
    <div
      className={
        luxury
          ? 'home-hero__copy home-hero__copy--editorial home-hero__copy--luxury'
          : immersive
            ? 'home-hero__copy home-hero__copy--editorial'
            : 'home-hero__copy home-hero__panel'
      }
    >
      <p className={compact ? 'home-hero__eyebrow home-hero__eyebrow--compact' : 'home-hero__eyebrow'}>{brandName}</p>
      <h1 className="home-hero__title">{title}</h1>
      {subtitle ? (
        <p
          className={
            compact ? 'home-hero__subtitle home-hero__subtitle--compact' : 'home-hero__subtitle handwritten'
          }
        >
          {subtitle}
        </p>
      ) : null}
      {!compact && !luxury && description ? <p className="home-hero__description">{description}</p> : null}
      <StorefrontHeroActions
        placement="home"
        compact={compact}
        className={
          compact
            ? 'home-hero__actions hero-actions shop-hero-actions d-flex flex-wrap align-items-center gap-2 mt-2'
            : luxury
              ? 'home-hero__actions home-hero__actions--luxury hero-actions shop-hero-actions d-flex flex-row flex-wrap align-items-center gap-2 gap-md-3 mt-0'
              : 'home-hero__actions hero-actions shop-hero-actions d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2 gap-sm-3'
        }
        giftFinderPlacement={compact || luxury ? null : 'home'}
        giftFinderClassName="btn btn-outline-secondary hero-secondary-cta btn-lg"
        primaryBtnClass={
          compact
            ? 'btn btn-primary hero-cta'
            : luxury
              ? 'btn btn-primary hero-cta btn-lg home-hero__cta--luxury'
              : 'btn btn-primary hero-cta btn-lg'
        }
        secondaryBtnClass={
          compact
            ? 'btn btn-outline-secondary hero-secondary-cta btn-sm'
            : luxury
              ? 'btn btn-primary hero-cta btn-lg home-hero__cta--luxury'
              : 'btn btn-outline-secondary hero-secondary-cta btn-lg'
        }
      />
      {!luxury && trustItems.length > 0 ? (
        <ul className="home-hero__trust" aria-label="Store highlights">
          {trustItems.map((item) => (
            <li key={item.key} className="home-hero__trust-item">
              <TrustIcon type={item.icon} />
              {item.label}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
